/* Video Vimeo functions */
global.$ = global.jQuery = require('jquery');

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Player from '@vimeo/player';

$(document).ready(function() {

    gsap.registerPlugin(ScrollTrigger);

    function getVimeoPlayerById(id) {
        let iframeVideo = getVimeoIframeById(id);
        let vimeoPlayer = null;
        if (iframeVideo) {
            vimeoPlayer = new Player(iframeVideo);
        }
        return vimeoPlayer;
    }

    function getVimeoIframeById(id) {
        let iframe = '#' + id + ' iframe';
        let iframeEl = $(iframe);
        if (iframeEl.length) {
            return iframeEl;
        }
        return null;
    }

    // Autoplay Video Reel
    function autoplayVimeoVideo(element) {
        let videoIframe = getVimeoIframeById(element);
        if (videoIframe) {
            videoIframe.attr('src', videoIframe.attr('src') + '&background=1&autoplay=1')
            return;
        }
        // Lazy-init: inject iframe behind placeholder, then remove the
        // placeholder after a short delay so the Vimeo player's initial
        // white frames don't show through.
        let container = document.getElementById(element);
        if (!container) return;
        let vimeoSrc = container.getAttribute('data-vimeo-src');
        if (!vimeoSrc) return;
        let placeholder = container.querySelector('img');
        if (!placeholder) return;
        let iframe = document.createElement('iframe');
        iframe.setAttribute('src', vimeoSrc + '&background=1&autoplay=1');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;';
        placeholder.parentNode.insertBefore(iframe, placeholder);
        setTimeout(function () {
            placeholder.style.transition = 'opacity 0.4s';
            placeholder.style.opacity = '0';
            setTimeout(function () { placeholder.remove(); }, 400);
        }, 1800);
    }

    // Volume button
    $('.video-vimeo-embedded .video-vimeo-embedded__volume').click(function (e) {
        e.preventDefault();
        let videoWrapperId = $(this).parent().attr('id');
        let videoVolumeIcon = $(this).find('i');
        let video = getVimeoPlayerById(videoWrapperId)
        if (video) {
            if (!$(this).hasClass('video-vimeo-embedded--volume-up')) {
                video.setVolume(1);
                video.play();
                headerHeadroom.unpin();
            } else {
                video.setVolume(0);
            }
            $(this).toggleClass('video-vimeo-embedded--volume-up');
            videoVolumeIcon.toggleClass('fa-volume-mute');
            videoVolumeIcon.toggleClass('fa-volume-up');
        }
    });

    // Clip-path reveal that plays once when each video section enters view
    gsap.utils.toArray('.video-vimeo-embedded > div').forEach((section) => {
        section.style.overflow = 'hidden';
        gsap.fromTo(section,
            {
                clipPath: 'inset(50% 80% 50% 80%)'
            },
            {
                clipPath: 'inset(0%)',
                duration: 2,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: section,
                    start: 'top 80%',
                    toggleActions: 'play none none none'
                }
            }
        );
    });

    // Trigger autoplayVideo if element is visible
    const trattiBullets = $('.tratti-bullet');
    if (document.querySelector('.video-vimeo-embedded')) {
        if (window.innerWidth >= 768) {
            // Preload the home reel immediately so Vimeo starts buffering on
            // page load instead of waiting for the scroll trigger to fire.
            autoplayVimeoVideo('videoreelhomedesk');
            let videoReelHomeDesktop = gsap.to("#videoreelhomedesk", {
                scrollTrigger: {
                    trigger: "#videoreelhomedesk",
                    onEnter: () => {
                        trattiBullets.addClass('tratti-bullet--hidden');
                        // autoplayVimeoVideo('videoreelhomedesk')
                    },
                    onEnterBack: () => {
                        trattiBullets.addClass('tratti-bullet--hidden');
                    },
                    onLeave: () => {
                        trattiBullets.removeClass('tratti-bullet--hidden');
                    },
                    onLeaveBack: () => {
                        trattiBullets.removeClass('tratti-bullet--hidden');
                    }
                }
            });
            let videoReelWorkDesktop = gsap.to("#videoReelWorkDesktop", {
                scrollTrigger: {
                    trigger: "#videoReelWorkDesktop",
                    onEnter: () => {
                        trattiBullets.addClass('tratti-bullet--hidden');
                        // autoplayVimeoVideo('videoReelWorkDesktop')
                    },
                    onEnterBack: () => {
                        trattiBullets.addClass('tratti-bullet--hidden');
                    },
                    onLeave: () => {
                        trattiBullets.removeClass('tratti-bullet--hidden');
                    },
                    onLeaveBack: () => {
                        trattiBullets.removeClass('tratti-bullet--hidden');
                    }
                }
            });
        }
        if (window.innerWidth < 768) {
            // Preload the home reel immediately so Vimeo starts buffering on
            // page load instead of waiting for the scroll trigger to fire.
            autoplayVimeoVideo('videoreelhomemob');
            let videoReelHomeMobile = gsap.to("#videoreelhomemob", {
                scrollTrigger: {
                    trigger: "#videoreelhomemob",
                    onEnter: () => {
                        trattiBullets.addClass('tratti-bullet--hidden');
                        // autoplayVimeoVideo('videoreelhomemob')
                    },
                    onEnterBack: () => {
                        trattiBullets.addClass('tratti-bullet--hidden');
                    },
                    onLeave: () => {
                        trattiBullets.removeClass('tratti-bullet--hidden');
                    },
                    onLeaveBack: () => {
                        trattiBullets.removeClass('tratti-bullet--hidden');
                    }
                }
            });
            let videoReelWorkMobile = gsap.to("#videoReelWorkMobile", {
                scrollTrigger: {
                    trigger: "#videoReelWorkMobile",
                    onEnter: () => {
                        trattiBullets.addClass('tratti-bullet--hidden');
                        // autoplayVimeoVideo('videoReelWorkMobile')
                    },
                    onEnterBack: () => {
                        trattiBullets.addClass('tratti-bullet--hidden');
                    },
                    onLeave: () => {
                        trattiBullets.removeClass('tratti-bullet--hidden');
                    },
                    onLeaveBack: () => {
                        trattiBullets.removeClass('tratti-bullet--hidden');
                    }
                }
            });
        }
    }
});
